import type { z } from 'zod';

import { NonEmptyText } from './non-empty-text';

// TODO: Add validation for HealthcareUserId
export const HealthcareSessionId = NonEmptyText;

export type HealthcareSessionId = z.infer<typeof HealthcareSessionId>;
